import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/auth';

const AuthDebugInfo: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth();
  
  const storedUser = localStorage.getItem('user');
  const storedToken = localStorage.getItem('access_token');
  const authServiceUser = authService.getCurrentUser();
  const authServiceIsAuth = authService.isAuthenticated();
  
  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-sm">
      <h3 className="font-bold text-yellow-800 mb-2">Authentication Debug Info</h3>
      <div className="space-y-1 text-yellow-700">
        <div><strong>Context isAuthenticated:</strong> {String(isAuthenticated)}</div>
        <div><strong>Context isLoading:</strong> {String(isLoading)}</div>
        <div><strong>Context user:</strong> {user ? `${user.name} (${user.role})` : 'null'}</div>
        <div><strong>AuthService isAuth:</strong> {String(authServiceIsAuth)}</div>
        <div><strong>AuthService user:</strong> {authServiceUser ? `${authServiceUser.name} (${authServiceUser.role})` : 'null'}</div>
        <div><strong>localStorage user:</strong> {storedUser ? 'exists' : 'null'}</div>
        <div><strong>localStorage token:</strong> {storedToken ? 'exists' : 'null'}</div>
      </div>
    </div>
  );
};

export default AuthDebugInfo;